export const suctionFrag = `
  precision mediump float;

  uniform sampler2D tDiffuse;
  uniform vec2 suctionPointUV;
  uniform float strength;
  uniform float aspectRatio;

  varying vec2 vUv;

  void main() {
    vec2 pUv = suctionPointUV * 0.5 + 0.5; // -1~1 => 0~1
    vec2 diff = vUv - pUv;

    diff.x *= aspectRatio;
    float dist = length(diff);

    vec2 uv = vUv;
    vec4 color = texture2D(tDiffuse, uv);

    float effect = 0.;
    float radius = aspectRatio > 1. ? 1. : 1. * aspectRatio;
    radius *= .5;

    if (dist < radius) {
      effect = 1. - smoothstep(-.5, 1., dist / radius);
      effect = pow(effect, 2.);
      effect *= strength;

      color.rgb = vec3(1., 0., effect);
      gl_FragColor = color;
      // return;
    }

    diff.x /= aspectRatio;
    vec2 displace = diff * effect;
    uv += displace;

    uv.xy = clamp(uv.xy, 0., 1.);

    gl_FragColor = texture2D(tDiffuse, uv);
}
`;